import { Schema as S } from "effect";

export const GetPatientFromCardRequestSchema = S.Struct({
  CtId: S.String,
  // Vendor post-processing wait; the bridge owns the overall attempt deadline.
  timeout: S.optional(S.Number.check(S.isInt(), S.isGreaterThanOrEqualTo(0), S.isLessThanOrEqualTo(5000))),
  SMCBCard: S.Struct({
    CardHandle: S.String,
    CardType: S.String,
  }),
  context: S.Struct({
    ClientSystemId: S.String,
    MandantId: S.String,
    WorkplaceId: S.String,
  }),
});

export type GetPatientFromCardRequest = S.Schema.Type<typeof GetPatientFromCardRequestSchema>;
